import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dropdown", "startDate", "endDate", "label"];

  connect() {
    this.closeDropdowns = (event) => {
      this.element.querySelectorAll("details.dropdown[open]").forEach((details) => {
        if (!details.contains(event.target)) {
          details.removeAttribute("open");
        }
      });
    };
    document.addEventListener("click", this.closeDropdowns);
  }

  disconnect() {
    document.removeEventListener("click", this.closeDropdowns);
  }

  selectPreset(event) {
    event.preventDefault();
    const range = event.currentTarget.dataset.range;
    this.navigateWithRange({ range });
  }

  applyCustomRange(event) {
    event.preventDefault();
    const startDate = this.startDateTarget.value;
    const endDate = this.endDateTarget.value;

    if (!startDate || !endDate) return;
    if (startDate > endDate) return;

    this.navigateWithRange({
      range: "custom",
      start_date: startDate,
      end_date: endDate,
    });
  }

  canonicalizePage(event) {
    const pageResetMarker = event.target.querySelector(
      "[data-analytics-page-reset='true']",
    );
    if (!pageResetMarker) return;

    const url = new URL(window.location);
    url.searchParams.delete("page");
    window.history.replaceState(window.history.state, "", url.toString());
  }

  navigateWithRange(params) {
    const url = new URL(window.location);
    // Clear old date params
    url.searchParams.delete("start_date");
    url.searchParams.delete("end_date");
    url.searchParams.delete("page");

    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        url.searchParams.set(key, value);
      }
    });

    // Close dropdown
    if (this.hasDropdownTarget) {
      this.dropdownTarget.removeAttribute("open");
    }

    Turbo.visit(url.toString());
  }
}
